import React from 'react'
import PropTypes from 'prop-types'

const DotIcon = ({ testId }) => (
  <div
    data-testid={testId}
    className="dot-icon"
  />
)

DotIcon.propTypes = {
  testId: PropTypes.string,
}

export default DotIcon
